// @flow
import styled from 'styled-components';
import { bounceEffect, finishBounceEffect } from '~/core/constants/animations';

export const Bounce = styled.div`
    animation: ${props => {
        const animationMap = new Map([
            [true, 'none'],
            [props.bounce, `${bounceEffect} 1s ease-in-out infinite`],
            [props.finishBounce, `${finishBounceEffect} 1s ease-in-out`]
        ]);
        return animationMap.get(true);
    }};
    height: ${p => (p.usePadding ? '0' : '100%')};
    padding-bottom: ${p => (p.usePadding ? '100%' : '0')};
    pointer-events: ${p => (p.bounce ? 'none' : 'inherit')};
    transition: all 0.3 ease-in;
    user-select: none;
    width: 100%;
    border-radius: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/bounce-effect/styles.js